import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { API_URL } from "services/config";
import { getColor } from "utils/colors";

const getRows = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        tipoDeResiduo: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.tipoDeResiduo}
            </SoftTypography>
          </SoftBox>
        ),
        descripcion: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.descripcion}
            </SoftTypography>
          </SoftBox>
        ),
        dispositivoDeMedicion: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.dispositivoDeMedicion ? "Sí" : "No"}
            </SoftTypography>
          </SoftBox>
        ),
        dispositivoDeDepuracion: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.dispositivoDeDepuracion ? "Sí" : "No"}
            </SoftTypography>
          </SoftBox>
        ),
        frecuenciaDeEmisiones: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.frecuenciaDeEmisiones}
            </SoftTypography>
          </SoftBox>
        ),
        observaciones: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="black"
              fontWeight="medium"
            >
              {item?.observaciones || "Sin observaciones"}
            </SoftTypography>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "tipoDeResiduo", desc: "Tipo de Residuo", align: "center", noOrder: true, width: "1%" },
  { name: "descripcion", desc: "Descripción", align: "left", noOrder: true },
  { name: "dispositivoDeMedicion", desc: "Dispositivo de Medición", align: "left", noOrder: true },
  { name: "frecuenciaDeEmisiones", desc: "Frecuencia de Emisiones", align: "left", noOrder: true },
  {
    name: "dispositivoDeDepuracion",
    desc: "Dispositivo de Depuración",
    align: "left",
    noOrder: true,
  },
  { name: "observaciones", desc: "Observaciones", align: "left", noOrder: true },
];

export default { columns, getRows };
